<!-- <div id="compliance-content-container"> -->
<div class="row">
  <div class="col-sm-12">
    <div class="container-white">
      <div class="ui-progress-status-bar">
        <ol>
          <li class="current">
            <span class="stepnum">1</span>
            Select Subgroups
          </li>
          <li class="">
            <span class="stepnum">2</span>
            Review & Complete
          </li>
        </ol>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col-sm-8" align="left">
          <div class="icon-utility-import img-link">
          </div>
          <label>&nbsp;Import Data</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-10" align="left">
          <input type="file" (change)="uploadFile($event.target.files)" />
        </div>
      </div>
      <br />
      <br />
      <div class="row">
        <div class="col-sm-3">
          <label>Adoption Agreement Type</label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <select [(ngModel)] = "adoptionAgreementType" class="form-control" (change)='loadAADocuments($event)'>
            <option value="Select" >--Select--</option>
            <option value="Restatement">Restatement</option>
            <option value="NonRestatement">Non-Restatement</option>
          </select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-3">
          <label>Plan Type</label>
        </div>
      </div>
      <div class="row" dis>
        <div class="col-sm-3">
          <select 
            [(ngModel)] = "planType" 
            [disabled] = "disablePlanTypeAndAvailableSG" 
            class="form-control" 
            (change)='filterPlanType($event)'
          >
            <option value="All Plan Types">All Plan Types</option>
            <option value="RS">RS</option>
            <option value="401K">401K</option>
          </select>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-sm-3">
          <label>Co-op / Subgroup</label>
        </div>
      </div>
    <div class="row">
        <div class="col-sm-3">
          <input [(ngModel)] = "coopSubgroup"  [disabled] = "disablePlanTypeAndAvailableSG"class="form-control" type="text" (keyup)="pickListFilter($event)" />
        </div>
    </div>
    <br />
    <div class="row" *ngIf="!hideEffectiveDateForRestatement">
      <div class="col-sm-3">
         <label>Effective Date</label>
      </div>
   </div>
   <div class="row" *ngIf="!hideEffectiveDateForRestatement">
      <div class="col-sm-4">
         <p class="input-group">
            <p-datepicker   (keyup)="pickListFilterByEffectiveDate($event)"  (onSelect)="pickListFilterByEffectiveDate($event)"
                placeholder="MM/DD/YYYY"           
                #effectiveDatecalendar> 
            </p-datepicker>&nbsp;
            <span class = "input-group-btn eefectiveDate-calendar" style="display:inline"  >
            <a   (click)="effectiveDatecalendar.toggle()"><i class="icon-utility-calendar"></i></a>
            </span>
         </p>
      </div>
   </div>
      <br />
     
      <div id=subgroupPicklist>
        <p-pickList
          [source]="filteredAvailableSubgroupsList" 
          [target]="selectedSubgroupsList"
          dragdrop="true"
          dragdropScope=""
          [responsive]="true"
          [sourceStyle]="{'height':'30em'}"
          [targetStyle]="{'height':'30em'}"
          ui-picklist-buttons
          [showSourceControls]="false"
          [showTargetControls]="false"
          (onMoveToTarget)="outPutSelections()"
          (onMoveToSource)="outPutRemovals()"
        >
          <ng-template pTemplate="sourceHeader" class="p-0">
            <div>
              Available Subgroups ({{ filteredAvailableSubgroupsList.length }})
            </div>
          </ng-template>
          <ng-template pTemplate="targetHeader">
            <div>
              Selected Subgroups ({{selectedSubgroupsList.length}})
            </div>
          </ng-template>

          <ng-template let-availableSubgroupsList pTemplate="item" >
            <div class="picklist-item"  title="{{availableSubgroupsList}}">
              {{availableSubgroupsList}}
            </div>
          </ng-template>
         
        </p-pickList>
      </div>

      <br />
      <div class="message-error" *ngIf="selectedSubgroupsList.length == 0">
        <span>Adoption Agreements(s) must be selected in order to continue with the transaction.</span>
      </div>
      <div>
        <br />
        <button (click)="navigateToStep2()" class="btn btn-primary">Next</button>
      </div>
    </div>
  </div>
</div>
